<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-5 row-cols-lg-5 row-cols-xl-5">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Kỳ" :options="category_sKY" :initialValue="modelSearch.idKy"
                                :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(e) => { modelSearch.idKy = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Phường/Xã" :options="category_PHUONGXA"
                                :initialValue="modelSearch.phuongXaId" :isMultiple="false" :isAllowClear="true" :isRequire="false"
                                @onChange="(e) => { modelSearch.phuongXaId = e ? e : null; handlePageChange(1) }" />
                        </div>
                        <div class="col mb-3">
                            <TheSelect title="Hiển thị trên cổng" :options="category_ENABLED"
                                :initialValue="modelSearch.enabled" :isMultiple="false" :isAllowClear="true"
                                :isRequire="false"
                                @onChange="(e) => { modelSearch.enabled = e; handlePageChange(1) }" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="currentSearchType == typeDataList.CURRENT_LIST.id">{{ $t('labels.currentList') }}</b>
                        <b v-if="currentSearchType == typeDataList.DELETED_LIST.id">{{ $t('labels.deletedList') }}</b>
                    </h3>
                    <div class="card-tools">
                        <TheSwapButton v-model="currentSearchType" @button-clicked="handlePageChange(1)" />
                        <button type="button" class="btn btn-tool" data-toggle="dropdown" :title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.RESTORE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.RESTORE] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.DELETE_TEMP" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE_TEMP] :isDivider="true">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                        v-model="navigateCode.DELETE" :onClick="confirmList"
                                        :submitArgs=[navigateCode.DELETE] :isDivider="true">
                                    </TheButtonInDropdown>

                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.ON_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.ON_ENABLED] :isDivider="false">
                                    </TheButtonInDropdown>
                                    <TheButtonInDropdown v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                        v-model="navigateCode.OFF_ENABLED" :onClick="confirmList"
                                        :submitArgs=[navigateCode.OFF_ENABLED] :isDivider="true">
                                    </TheButtonInDropdown>
                                </div>
                            </div>
                        </button>
                        <TheCreateButton :onClickParent="() => { detail(null, 'create') }" />
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th style="width:5%">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <div class="custom-control custom-checkbox">
                                                <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                    @click="selectAllRows($event)">
                                                <label for="checkboxAll" class="custom-control-label"></label>
                                            </div>
                                        </div>
                                    </th>
                                    <th class="cursor col" style="width:5%" @click="handleSortChange('thethaoSunghiepId')" title="Sắp xếp theo ID">
                                        ID
                                        <span v-if="sortBy == 'thethaoSunghiepId'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col-2 cursor" @click="handleSortChange('tenPhuongXa')" tilte="Sắp xếp theo tên phường xã">
                                        Phường xã
                                        <span v-if="sortBy == 'tenPhuongXa'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>

                                    <th class="col-2 cursor" @click="handleSortChange('tenKy')" tilte="Sắp xếp theo tên kỳ">
                                        Kỳ
                                        <span v-if="sortBy == 'tenKy'" aria-hidden="true"
                                            class="text-primary f-right">
                                            <i v-if="orderDesc == false" class="fas fa-arrow-up" ara-hidden="true"></i>
                                            <i v-if="orderDesc == true" class="fas fa-arrow-down" ara-hidden="true"></i>
                                        </span>
                                    </th>
                                    <th class="col-1">Tỷ lệ số dân</th>
                                    <th class="col-1">Tập luyện</th>
                                    <th class="col-1">Lớp bơi</th>
                                    <th class="col-1">Người bơi</th>
                                    <th class="col-1">Hiển thị trên cổng</th>
                                    <th class="col-1 sticky-action">Hành động</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item._id">
                                    <td @click="selectRow(item.thethaoSunghiepId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <span v-if="(csList_Navigate.csList.includes(item.thethaoSunghiepId))" class="text-primary">&check;</span>
                                            <span v-else>&nbsp;</span>
                                        </div>
                                    </td>
                                    <td>{{ item.thethaoSunghiepId }}</td>
                                    <td>{{ item.tenPhuongXa }}</td>
                                    <td>{{ item.tenKy }}</td>
                                    <td>{{ item.tyLeSoDan }}</td>
                                    <td>
                                        <p style="margin-bottom: 5px;">Tỷ lệ: {{ item.tyLeTapLuyen }}</p>
                                        <span><strong>Chỉ tiêu: </strong>{{ item.chiTieuTapLuyen }}</span> <br />
                                        <span><strong>Thực hiện: </strong>{{ item.thucHienTapLuyen }}</span>
                                    </td>
                                    <td>
                                        <p style="margin-bottom: 5px;">Tỷ lệ: {{ item.tyLeBoiLop }}</p>
                                        <span><strong>Chỉ tiêu: </strong>{{ item.chiTieuBoiLop }}</span> <br />
                                        <span><strong>Thực hiện: </strong>{{ item.thucHienBoiLop }}</span>
                                    </td>
                                    <td>
                                        <p style="margin-bottom: 5px;">Tỷ lệ: {{ item.tyLeBoiNguoi }}</p>
                                        <span><strong>Chỉ tiêu: </strong>{{ item.chiTieuBoiNguoi }}</span> <br />
                                        <span><strong>Thực hiện: </strong>{{ item.thucHienBoiNguoi }}</span>
                                    </td>
                                    <td>
                                        <TheSwitchInTable 
                                        :placeholder="'Thay đổi hiển thị trên cổng '"
                                        v-model:initialValue="item.enabled" 
                                        :isReadOnly="currentSearchType == typeDataList.DELETED_LIST.id"
                                        :onChange="(e) => { navigateEnabledChange(item.thethaoSunghiepId, e.target.checked) }"
                                        ></TheSwitchInTable>
                                    </td>
                                    <td class="sticky-action">
                                        <TheButtonInTable
                                            v-model="tableButton.VIEWDETAIL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DETAIL]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.EDIT" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.UPDATE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.CURRENT_LIST.id"
                                            v-model="tableButton.DELETE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE_TEMP]">
                                        </TheButtonInTable>
                                        
                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.DELETE_REAL" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.DELETE]">
                                        </TheButtonInTable>

                                        <TheButtonInTable 
                                            v-if="currentSearchType == typeDataList.DELETED_LIST.id"
                                            v-model="tableButton.RESTORE" 
                                            :onClick="detail"
                                            :submitArgs="[item, navigateCode.RESTORE]">
                                        </TheButtonInTable>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <TheCRUDFrameModal ref="modalCRUDRef" idModal="crudModal" dialogClass=" modal-lg" :headerTitle="title"
        :displaySubmit="loadingSubmit" :onSubmit="handleSubmit" :titleSubmit="title" :styleButton="styleButton"
        v-model:showModalFlag="isShowModal.CRUDModal">
        <div class="row">
                        <div class="col-md-4">
                            <TheSelect title="Phường xã" :options="category_PHUONGXA" :initialValue="model.phuongXaId"
                                :error="errors.phuongXaId" :isMultiple="false" :isReadOnly="isReadOnly"
                                :isAllowClear="true" :isRequire="true" @onChange="(e) => { model.phuongXaId = e }"
                                :key="tempKey" />
                        </div>
                        <div class="col-md-4">
                            <TheSelect title="Kỳ" :options="category_sKY" :initialValue="model.idKy" :error="errors.idKy"
                                :isMultiple="false" :isReadOnly="isReadOnly" :isAllowClear="true" :isRequire="true"
                                @onChange="(e) => { model.idKy = e }" :key="tempKey" />
                        </div>

                        <div class="col-md-4">
                            <TheInputText title="Tỷ lệ số dân" placeholder="Nhập tỷ lệ số dân"
                                :initialValue="model.tyLeSoDan" v-model="model.tyLeSoDan" :error="errors.tyLeSoDan"
                                :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false" :key="tempKey" />
                        </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <TheInputText title="Chỉ tiêu tập luyện" placeholder="Nhập chỉ tiêu tập luyện"
                    :initialValue="model.chiTieuTapLuyen" v-model="model.chiTieuTapLuyen"
                    :error="errors.chiTieuTapLuyen" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheInputText title="Thực hiện tập luyện" placeholder="Nhập thực hiện tập luyện"
                    :initialValue="model.thucHienTapLuyen" v-model="model.thucHienTapLuyen"
                    :error="errors.thucHienTapLuyen" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheInputText title="Tỷ lệ tập luyện" placeholder="Nhập tỷ lệ tập luyện"
                    :initialValue="model.tyLeTapLuyen" v-model="model.tyLeTapLuyen"
                    :error="errors.tyLeTapLuyen" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <TheInputText title="Chỉ tiêu lớp bơi" placeholder="Nhập chỉ tiêu lớp bơi"
                    :initialValue="model.chiTieuBoiLop" v-model="model.chiTieuBoiLop"
                    :error="errors.chiTieuBoiLop" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheInputText title="Thực hiện lớp bơi" placeholder="Nhập thực hiện lớp bơi"
                    :initialValue="model.thucHienBoiLop" v-model="model.thucHienBoiLop"
                    :error="errors.thucHienBoiLop" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheInputText title="Tỷ lệ lớp bơi" placeholder="Nhập tỷ lệ lớp bơi"
                    :initialValue="model.tyLeBoiLop" v-model="model.tyLeBoiLop" :error="errors.tyLeBoiLop"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="false" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <TheInputText title="Chỉ tiêu người bơi" placeholder="Nhập chỉ tiêu người bơi"
                    :initialValue="model.chiTieuBoiNguoi" v-model="model.chiTieuBoiNguoi"
                    :error="errors.chiTieuBoiNguoi" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheInputText title="Thực hiện người bơi" placeholder="Nhập thực hiện người bơi"
                    :initialValue="model.thucHienBoiNguoi" v-model="model.thucHienBoiNguoi"
                    :error="errors.thucHienBoiNguoi" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
            <div class="col-md-4">
                <TheInputText title="Tỷ lệ người bơi" placeholder="Nhập tỷ lệ người bơi"
                    :initialValue="model.tyLeBoiNguoi" v-model="model.tyLeBoiNguoi"
                    :error="errors.tyLeBoiNguoi" :isReadOnly="isReadOnly" :isRequire=false
                    :isMultipleLine="false" :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <TheInputText title="Ghi chú" placeholder="Nhập ghi chú"
                    :initialValue="model.ghiChu" v-model="model.ghiChu" :error="errors.ghiChu"
                    :isReadOnly="isReadOnly" :isRequire=false :isMultipleLine="true"
                    :key="tempKey" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <TheSwitchButton  title="Hiển thị trên cổng" placeholder="Chọn hiển thị trên cổng" :isReadOnly="isReadOnly" :isRequire=false :key="tempKey" :error="''" v-model:initialValue="model.enabled"> </TheSwitchButton>
            </div>
        </div>
    </TheCRUDFrameModal>

    <TheDetailFrameModal ref="modalDetailRef" idModal="detailModal" dialogClass=" modal-lg"
        :headerTitle="'Chi tiết'" v-model:showModalFlag="isShowModal.detailModal">
        <div class="row" v-if="modelRec">
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm">ID:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.thethaoSunghiepId
                        }}&nbsp;</b>
                </p>
                
                <p class="text-sm">Phường xã:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.phuongXaId }}&nbsp;</b>
                </p>
                <p class="text-sm">Kỳ:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tenKy }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ số dân:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeSoDan }}&nbsp;</b>
                </p>
            </div>
            <div class="col-12 col-md-12 col-lg-4 order-1 order-md-2">
                <p class="text-sm">Chỉ tiêu tập luyện:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.chiTieuTapLuyen }}&nbsp;</b>
                </p>
                <p class="text-sm">Thực hiện tập luyện:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.thucHienTapLuyen }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ tập luyện:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeTapLuyen }}&nbsp;</b>
                </p>
            </div>
            <div class="col-12 col-md-12 col-lg-4 order-1 order-md-2">
                <p class="text-sm">Chỉ tiêu lớp bơi:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.chiTieuBoiLop }}&nbsp;</b>
                </p>
                <p class="text-sm">Thực hiện lớp bơi:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.thucHienBoiLop }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ lớp bơi:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeBoiLop }}&nbsp;</b>
                </p>
            </div>
            <div class="col-12 col-md-12 col-lg-4 order-1 order-md-2">
                <p class="text-sm">Chỉ tiêu người bơi:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.chiTieuBoiNguoi }}&nbsp;</b>
                </p>
                <p class="text-sm">Thực hiện người bơi:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.thucHienBoiNguoi }}&nbsp;</b>
                </p>
                <p class="text-sm">Tỷ lệ người bơi:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.tyLeBoiNguoi }}&nbsp;</b>
                </p>
            </div>
            <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                <p class="text-sm">Ghi chú:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.ghiChu }}&nbsp;</b>
                </p>
                <p class="text-sm">Hiển thị trên cổng:
                    <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.enabled ? "Có" : "Không"
                        }}&nbsp;</b>
                </p>
            </div>
        </div>
    </TheDetailFrameModal>
    <TheConfirmDialogModal :title="csList_MapModel.title"
        :confirmLabelButton="csList_MapModel.confirmLabelButton" :onClose="csList_MapModel.onClose"
        :onSubmit="csList_MapModel.onSubmit" :modalContent=csList_MapModel.modalContent
        :isReConfirm=csList_MapModel.isReConfirm :reConfirmMes=csList_MapModel.reConfirmMes
        v-model:showModalFlag="isShowModal.confirmDialogModal"></TheConfirmDialogModal>
    <TheCheckboxConfirmDialogModal :title="csListEnabled_MapModel.title"
        :confirmLabelButton="csListEnabled_MapModel.confirmLabelButton"
        :onClose="csListEnabled_MapModel.onClose" :onSubmit="csListEnabled_MapModel.onSubmit"
        :modalContent=csListEnabled_MapModel.modalContent :key="tempKey"
        :submitArgs="csListEnabled_MapModel.submitArgs" v-model="checkEnable_Memo"
        v-model:showModalFlag="isShowModal.checkBoxConfirmModal">
    </TheCheckboxConfirmDialogModal>



</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import { common } from '@/helper/common';
import objectDefaultValue from '@/config/object.env'
import tableValue from '@/config/table.env'
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';

import TheSwapButton from '@/components/shareComponents/table/button/TheSwapButton.vue'
import TheCreateButton from '@/components/shareComponents/table/button/TheCreateButton.vue'
import TheButtonInDropdown from '@/components/shareComponents/table/button/TheButtonInDropdown.vue'
import TheButtonInTable from '@/components/shareComponents/table/button/TheButtonInTable.vue'

import TheSwitchButton from '@/components/shareComponents/TheSwitchButton.vue'
import TheDetailFrameModal from '@/components/shareComponents/modal/TheDetailFrameModal.vue'
import TheCRUDFrameModal from '@/components/shareComponents/modal/TheCRUDFrameModal.vue'
import TheCheckboxConfirmDialogModal from '@/components/shareComponents/modal/TheCheckboxConfirmDialogModal.vue'
import TheConfirmDialogModal from '@/components/shareComponents/modal/TheConfirmDialogModal.vue'

import TheSwitchInTable from '@/components/shareComponents/table/switch/TheSwitchInTable.vue'

import { theThaoSuNghiepModel } from '@/models/thethao/theThaoSuNghiep.model'
import { tableInteractiveModel } from '@/models/general/tableInteractive.model'

export default {
    name: "TheTheThaoSuNghiep",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        TheSwapButton,
        TheCreateButton,
        TheButtonInDropdown,
        TheButtonInTable,
        TheDetailFrameModal,
        TheCRUDFrameModal,
        TheCheckboxConfirmDialogModal,
        TheConfirmDialogModal,
        TheSwitchButton,
        TheSwitchInTable,

    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],
            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadOnly: null,

            modelRec: theThaoSuNghiepModel.newModel(),
            model: theThaoSuNghiepModel.newFEModel(),
            errors: theThaoSuNghiepModel.errors(),
            modelSearch: theThaoSuNghiepModel.newPagingSearchModel(),

            csList_Navigate: tableInteractiveModel.newList_NavigateModel(),
            csList_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            acceptImageType: objectDefaultValue.ACCEPT_TYPE_IMG,
            acceptTypeExcel: objectDefaultValue.ACCEPT_TYPE_EXCEL,

            cEnable_Item: null,
            checkEnable_Memo: false,

            category_ENABLED: objectDefaultValue.ENABLED_SELECTION,
            category_PHUONGXA: [],
            category_cKY: [],
            category_sKY: [],
            csListEnabled_MapModel: tableInteractiveModel.newListEnabled_MapModel(),

            isShowModal: {
                CRUDModal: false,
                detailModal: false,
                checkBoxConfirmModal: false,
                confirmDialogModal: false,
            },
            loadingSubmit: false,
            tempKey: common.randomString(10),

            currentSearchType: objectDefaultValue.TYPEDATA_LIST.CURRENT_LIST.id,
            navigateCode: objectDefaultValue.NAVIGATECODE_VALUE,
            navigateList: objectDefaultValue.NAVIGATECODE_LIST,
            typeDataList: objectDefaultValue.TYPEDATA_LIST,
            tableButton: objectDefaultValue.TABLEBUTTON,

        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('validate', ['validateRequired', 'validateNumber', 'validateFloat'],),
        ...mapActions('handleData2', ['handleTypeImport', 'handleChangeType', 'formatData']),
        ...mapActions('thethaoSunghiep', ['getPagingThethaoSunghiep', 'getDetailThethaoSunghiep', 'getCustomDetailThethaoSunghiep', 'checkExistThethaoSunghiep', 'createThethaoSunghiep', 'updateThethaoSunghiep', 'deleteThethaoSunghiep', 'restoreThethaoSunghiep', 'handleListThethaoSunghiep', 'setEnabledThethaoSunghiep', 'exportExcelThethaoSunghiep', 'getMapInfoThethaoSunghiep', 'importExcelThethaoSunghiep']),
        ...mapActions('dmKy', ['getBasicDMKy']),
        ...mapActions('phuongXa', ['getsPhuongXa']),

        async setup() {
            let header = 'Danh sách Sự nghiệp thể thao'
            this.setupHeader({ header })
        },

        async initialize() {
            this.category_PHUONGXA = await this.getCategory_PhuongXa()
        },
        //#region TableNavigation
        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.modelSearch.sort = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.modelSearch.sort = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
            await this.navigateCheckBoxAll()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },
        async showEnabledConfirmModal() {
            this.csListEnabled_MapModel = {
                title: "XÁC NHẬN",
                confirmLabelButton: "Xác nhận",
                onClose: this.closeConfirmEnabledChange,
                onSubmit: this.updateEnabled,
                submitArgs: [2],
                modalContent: "<label>Bạn có chắc chắn muốn thay đổi hiển thị trên cổng?</label>",
            }
            this.isShowModal.checkBoxConfirmModal = true
        },
        async navigateEnabledChange(id,  value) {
            if (!this.checkEnable_Memo) {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                await this.showEnabledConfirmModal()
            }
            else {
                this.cEnable_Item = {
                    id: id,
                    enabled: value
                }
                this.updateEnabled()
            }
        },
        async updateEnabled() {
            let model = {
                thethaoSunghiepId: this.cEnable_Item.id,
                enabled: this.cEnable_Item.enabled
            }
            await this.setEnabledThethaoSunghiep({ model: model }).then(async resp => {
                if (resp) {
                    this.isShowModal.checkBoxConfirmModal = false
                }
                else {
                    const itemIndex = this.items.findIndex(item => item.thethaoSunghiepId === this.cEnable_Item.id);
                    if (itemIndex !== -1) {
                        this.items[itemIndex].enabled = !this.items[itemIndex].enabled;

                    } else {
                        await this.getData()
                    }
                }

            });
        },
        async closeConfirmEnabledChange() {
            const itemIndex = this.items.findIndex(item => item.thethaoSunghiepId === this.cEnable_Item.thethaoSunghiepId);
            if (itemIndex !== -1) {
                this.items[itemIndex].enabled = !this.items[itemIndex].enabled;
            } else {
                await this.getData()
            }
            this.isShowModal.checkBoxConfirmModal = false
        },
        async navigateCheckBoxAll() {
            if (this.items.length != 0 && this.items.length == this.csList_Navigate.csList.length) {
                document.getElementById("checkboxAll").checked = true;
            }
            else {
                document.getElementById("checkboxAll").checked = false;
            }
        },
        async selectRow(id) {
            if (this.csList_Navigate.csList.includes(id)) {
                this.csList_Navigate.csList.splice(this.csList_Navigate.csList.indexOf(id), 1)
            }
            else {
                this.csList_Navigate.csList.push(id)
            }
            await this.navigateCheckBoxAll()
        },
        async unSelectAllRows() {
            this.csList_Navigate.csList = []
            document.getElementById("checkboxAll").checked = false
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList_Navigate.csList = this.items.map((item) => {
                    return item.thethaoSunghiepId
                })
            }
            else {
                this.csList_Navigate.csList = []
            }
        },
        async standardizationFilter() {
            this.modelSearch.pageNumber = this.pageNumber
            this.modelSearch.pageSize = this.pageSize
            this.modelSearch.enabled = await this.handleChangeType({ input: this.modelSearch.enabled, typeChange: objectDefaultValue.changeTypeData.STRING_TO_BOOLEAN })
        },
        async getData() {
            this.isBusy = true
            this.csList_Navigate.csList = []
            await this.standardizationFilter()
            await this.unSelectAllRows()
            this.category_sKY = await this.getCategory_Ky(1)
            await this.getPagingThethaoSunghiep({ params: this.modelSearch, type: this.currentSearchType }).then(res => {
                // List data
                this.items = res.data
                this.totalRow = res.totalRow
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },
        //#endregion TableNavigation

        //#region CRUD
        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('style.styleButton' + code)
            this.styleTitle = this.$t('style.styleTitle' + code)
            this.errors = theThaoSuNghiepModel.errors()
            this.loadingSubmit = false
            this.category_cKY = await this.getCategory_Ky()
            if (this.code == this.navigateCode.UPDATE || this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) {
                let params = {
                    thethaoSunghiepId: item.thethaoSunghiepId
                }
                await this.getDetailThethaoSunghiep({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = theThaoSuNghiepModel.newModel()
                        this.modelRec = resp
                        this.model = theThaoSuNghiepModel.parseModeltoFEModel(this.modelRec)

                    }
                });
                this.isReadOnly = (this.code == this.navigateCode.DELETE || this.code == this.navigateCode.RESTORE || this.code == this.navigateCode.DELETE_TEMP) ? true : false
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
            else if (this.code == this.navigateCode.DETAIL) {
                let params = {
                    thethaoSunghiepId: item.thethaoSunghiepId
                }
                await this.getDetailThethaoSunghiep({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = theThaoSuNghiepModel.newModel()
                        this.modelRec = resp

                    }
                });
                this.tempKey = common.randomString(10)
                this.isShowModal.detailModal = true
            }
            else {
                this.model = theThaoSuNghiepModel.newFEModel()
                this.isReadOnly = false
                // show popup
                this.tempKey = common.randomString(10)
                this.isShowModal.CRUDModal = true
            }
        },
        async checkExistName(name) {
            let params = {
                ten: name
            }
            let res = await this.checkExistThethaoSunghiep({ params: params })
            return res.data
        },
        async validate(model) {
            let isvalid = true
            this.errors = theThaoSuNghiepModel.errors()
            if (!await this.validateRequired(model.idKy)) {
                this.errors.idKy = "Chọn kỳ"
                isvalid = false
            }

            if (!await this.validateRequired(model.phuongXaId)) {
                this.errors.phuongXaId = "Chọn phường xã"
                isvalid = false
            }

            if (!await this.validateFloat(model.tyLeSoDan)) {
                this.errors.tyLeSoDan = "Tỷ lệ số dân phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateFloat(model.chiTieuTapLuyen)) {
                this.errors.chiTieuTapLuyen = "Chỉ tiêu tập luyện phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateFloat(model.thucHienTapLuyen)) {
                this.errors.thucHienTapLuyen = "Thực hiện tập luyện phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateFloat(model.tyLeTapLuyen)) {
                this.errors.tyLeTapLuyen = "Tỷ lệ tập luyện phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateFloat(model.chiTieuBoiLop)) {
                this.errors.chiTieuBoiLop = "Chỉ tiêu lớp bơi phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateFloat(model.thucHienBoiLop)) {
                this.errors.thucHienBoiLop = "Thực hiện lớp bơi phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateFloat(model.tyLeBoiLop)) {
                this.errors.tyLeBoiLop = "Tỷ lệ lớp bơi phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateFloat(model.chiTieuBoiNguoi)) {
                this.errors.chiTieuBoiNguoi = "Chỉ tiêu người bơi phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateFloat(model.thucHienBoiNguoi)) {
                this.errors.thucHienBoiNguoi = "Thực hiện người bơi phải là kiểu số"
                isvalid = false
            }

            if (!await this.validateFloat(model.tyLeBoiNguoi)) {
                this.errors.tyLeBoiNguoi = "Tỷ lệ người bơi phải là kiểu số"
                isvalid = false
            }
            return isvalid
        },
        async modifySendModel(FEmodel) {
            let sendModel = theThaoSuNghiepModel.newModel()
            if (this.code == this.navigateCode.DELETE
                || this.code == this.navigateCode.RESTORE
                || this.code == this.navigateCode.DELETE_TEMP) sendModel.thethaoSunghiepId = FEmodel.thethaoSunghiepId
            else {
                if (this.code == this.navigateCode.UPDATE) sendModel.thethaoSunghiepId = FEmodel.thethaoSunghiepId
                sendModel.idKy = FEmodel.idKy
                sendModel.quanHuyenId = config.QUANHUYEN_SITEID
                sendModel.phuongXaId = FEmodel.phuongXaId
                sendModel.chiTieuTapLuyen = FEmodel.chiTieuTapLuyen
                sendModel.thucHienTapLuyen = FEmodel.thucHienTapLuyen
                sendModel.tyLeTapLuyen = FEmodel.tyLeTapLuyen
                sendModel.tyLeSoDan = FEmodel.tyLeSoDan
                sendModel.chiTieuBoiLop = FEmodel.chiTieuBoiLop
                sendModel.thucHienBoiLop = FEmodel.thucHienBoiLop
                sendModel.tyLeBoiLop = FEmodel.tyLeBoiLop
                sendModel.chiTieuBoiNguoi = FEmodel.chiTieuBoiNguoi
                sendModel.thucHienBoiNguoi = FEmodel.thucHienBoiNguoi
                sendModel.tyLeBoiNguoi = FEmodel.tyLeBoiNguoi
                sendModel.ghiChu = FEmodel.ghiChu
                sendModel.enabled = FEmodel.enabled ? FEmodel.enabled : false
            }
            return sendModel
        },
        async handleSubmit() {
            if (this.code === this.navigateCode.DELETE) {
                this.csList_MapModel = {
                    title: this.$t('labels.confirmDelete'),
                    confirmLabelButton: this.$t('buttons.confirm'),
                    onClose: null,
                    onSubmit: this.onSubmit,
                    modalContent: "<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>",
                }
                this.isShowModal.confirmDialogModal = true
            }
            else {
                await this.onSubmit()
            }
        },
        async onSubmit() {
            this.loadingSubmit = true
            let code = this.code
            let sendModel = await this.modifySendModel(this.model)
            let res = false
            switch (code) {
                case this.navigateCode.CREATE:
                    if (await this.validate(sendModel)) {
                        res = await this.createThethaoSunghiep({ model: sendModel })
                    }
                    break
                case this.navigateCode.UPDATE:
                    if (await this.validate(sendModel)) {
                        res = await this.updateThethaoSunghiep({ model: sendModel })
                    }
                    break
                case this.navigateCode.DELETE_TEMP:
                    res = await this.deleteThethaoSunghiep({ model: sendModel, type: this.currentSearchType })
                    break
                case this.navigateCode.DELETE:
                    res = await this.deleteThethaoSunghiep({ model: sendModel, type: this.currentSearchType })
                    if (res) this.isShowModal.confirmDialogModal = false
                    break
                case this.navigateCode.RESTORE:
                    res = await this.restoreThethaoSunghiep({ model: sendModel })
                    break
                default:
            }
            if (res) {
                this.isShowModal.CRUDModal = false
                await this.getData()
            }

            this.loadingSubmit = false
        },
        //#endregion CRUD
        //#region ListNavigation
        async confirmList(code) {
            if (this.csList_Navigate.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Navigate.csList_Code = code
                let foundItem = this.navigateList.find(item => item.code === code);
                this.csList_Navigate.csList_Title = foundItem ? foundItem.title : ""

                let tempReConfirmMes = code == this.navigateCode.DELETE ?"<span>Bạn có chắc chắn muốn <b> xóa vĩnh viễn </b>những dữ liệu đã chọn? </span><br/><span><b>Dữ liệu sau khi xóa sẽ không thể khôi phục lại</b></span>" : null
                this.csList_MapModel = {
                    isReConfirm: code == this.navigateCode.DELETE ? true : false,
                    reConfirmMes: tempReConfirmMes,
                    title: this.csList_Navigate.csList_Title,
                    confirmLabelButton: this.csList_Navigate.csList_Title,
                    onClose: null,
                    onSubmit: this.onSubmitList,
                    modalContent: "Bạn có chắc chắn <b>" + this.csList_Navigate.csList_Title + "</b> các dữ liệu đã chọn?",
                }
                this.isShowModal.confirmDialogModal = true
            }
        },

        async onSubmitList() {
            let code = this.csList_Navigate.csList_Code
            let modelSend = {
                model: {
                    listId: this.csList_Navigate.csList.toString()
                },
                type: code
            }
            if (code == this.navigateCode.OFF_ENABLED) {
                modelSend.model.enabled = false
            }
            if (code == this.navigateCode.ON_ENABLED) {
                modelSend.model.enabled = true
            }
            let res = null
            if (code == objectDefaultValue.NAVIGATECODE_VALUE.DELETE) {
                res = await this.handleListThethaoSunghiep(modelSend)
            }
            else {
                res = await this.handleListThethaoSunghiep(modelSend)
            }
            if (res) {
                await this.getData()
                await this.navigateCheckBoxAll()
                this.isShowModal.confirmDialogModal = false
            }
        },
        //#endregion ListNavigation
        async getCategory_PhuongXa() {
            let params = {
                quanHuyenId: config.QUANHUYEN_SITEID
            }
            let res = await this.getsPhuongXa({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].phuongXaId,
                            name: res[i].ten
                        }
                    )
                }
                return handleRes
            }

            return res
        },

        async getCategory_Ky(filterNumber = 0) {
            let params = {
                tableName: tableValue.TT_SUNGHIEPTHETHAO,
                loaiKy: 'Y'
            }
            params.filter = filterNumber
            let res = await this.getBasicDMKy({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].idKy,
                            name: res[i].tenKy
                        }
                    )
                }
                return handleRes
            }

            return res
        },
    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()
    }
}
</script>
<style>
</style>
